export const devices = {
  android: Symbol('android'),
  iOS: Symbol('iOS'),
};
